import { Controller } from '@hotwired/stimulus';
/*
 * Description
 * -------
 *
 * Sends events to WLA on click to open downloads page.
 *
 * Can be used on any element.
 * Can be used multiple times in the document.
 *
 * Usage
 * -------
 *
 * <button
 *   data-controller="wla-downloads-link"
 *   data-action="click->wla-downloads-link#openDownloads"
 * >
 *  Downloads
 * </button>
 */
export class WlaDownloadsLink extends Controller {
    openDownloads() {
        window.webkit?.messageHandlers?.showDownloads?.postMessage?.(true);
        window.Android?.openDownloads();
    }
}
